import { GuestResponseToPressure } from "../../../../../api/types/guests";
import { CafsVariable } from "../../../../../types/cafs-variable";
import { CafsVariableType } from "../../../const/cafs-variable-type";

export type UsePressureVariablesProps = {
  categories: { id: string; label: string }[];
};

export function useGuestPressureVariables({
  categories,
}: UsePressureVariablesProps): CafsVariable<GuestResponseToPressure>[] {
  return [
    { name: "Remarks", type: CafsVariableType.Remarks },
    {
      name: "Category",
      type: CafsVariableType.Select,
      options: categories,
    },
    {
      name: "REffect",
      type: CafsVariableType.Input,
    },
  ];
}
